<template>
	<TnCardHorizontal
		border
		compact
		:title="product.cleanName"
		:text="text"
	>
		<template #graphic>
			<NuxtImg
				class="device-image"
				:src="product.imageLink"
				height="36px"
			/>
		</template>
	</TnCardHorizontal>
</template>

<script>
import { mapState } from "vuex";

export default defineNuxtComponent({
	name: "ECommerceClickAndCollectProductCard",

	computed: {
		...mapState("ecommerce", ["product"]),
		text() {
			if (this.product.color && this.product.memory) {
				return `${this.product.color || ""}, ${this.product.memory}`;
			} else if (this.product.color) {
				return this.product.color;
			} else if (this.product.memory) {
				return this.product.memory;
			}

			return "";
		},
	},
});
</script>
